module.exports = __webpack_public_path__ + "img/no-name.5667d184.svg";